import axios from 'axios';
import Cookies from 'js-cookie';

export default async function getAccessToken(clientId) {
  const oneHourFromNow = new Date(Date.now() + 60 * 60 * 1000);
  try {
    const responseGrantCode = await axios.post(
      process.env.REACT_APP_API_URL + process.env.REACT_APP_OAUTH_PATH,
      {
        client_id: clientId,
        redirect_uri: 'http://localhost/',
      },
    );

    const grantCode = responseGrantCode.data.redirect_uri.replace(
      'http://localhost/?code=',
      '',
    );

    const responseAccessToken = await axios.post(
      process.env.REACT_APP_API_URL + process.env.REACT_APP_ACCESS_TOKEN_PATH,
      {
        grant_type: 'authorization_code',
        code: grantCode,
      },
      {
        headers: {
          Authorization: `Basic ${process.env.REACT_APP_BASIC_AUTH}`,
        },
      },
    );

    Cookies.set('access_token', responseAccessToken.data.access_token, {
      expires: oneHourFromNow,
    });

    return responseAccessToken.data.access_token;
  } catch (error) {
    throw error;
  }
}
